import * as types from "./empTypes";

//FOR UPDATING EMPLOYEE
export const updateEmployeeRequest = (updatedEmployee) => ({
    type: types.UPDATE_EMPLOYEE_REQUEST,
    payload: updatedEmployee
});

export const updateEmployeeSuccess = (updatedEmployee) => ({
    type: types.UPDATE_EMPLOYEE_SUCCESS,
    payload: updatedEmployee,
});

export const updateEmployeeFailure = (error) => ({
    type: types.UPDATE_EMPLOYEE_FAILURE,
    payload: error,
});


//FOR FETCHING EMPLOYEE
export const fetchEmployeeRequest = (id) => (
    // ////console.log(id),
    {
    type: types.FETCH_EMPLOYEE_REQUEST,
    payload: id,
});

export const fetchEmployeeSuccess = (data) => ({
    type: types.FETCH_EMPLOYEE_SUCCESS,
    payload: data,
});

export const fetchEmployeeFailure = (error) => ({
    type: types.FETCH_EMPLOYEE_FAILURE,
    payload: error,
});


//FOR DELETING EMPLOYEE

export const deleteEmployeeRequest = (employee,id ) => (
    ////console.log(id),
    {
    type: types.DELETE_EMPLOYEE_REQUEST,
    payload: employee,
});

export const deleteEmployeeSuccess = (id) => (
    ////console.log(id),
    {
    type: types.DELETE_EMPLOYEE_SUCCESS,
    payload: id,
});

export const deleteEmployeeFailure = (error) => ({
    type: types.DELETE_EMPLOYEE_FAILURE,
    payload: error,
});


